import { Component, Inject, Injector, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { XyzLayerComponent } from "./xyz-layer.component";
import { PhoenixXyzLayerResultsDialogComponent } from "../xyz-layer-result-dialog/phoenix-xyz-layer-results-dialog.component";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "phoenix-xyz-component",
  templateUrl: "./xyz-layer.component.html",
  styleUrls: ["./xyz-layer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixXyzLayerComponent extends XyzLayerComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    geoJSONDatabaseService: GeoJSONDatabaseService,
    matDialog: MatDialog,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
    public injector: Injector,
  ) {
    super(http, viewerConfigurationService, geoJSONDatabaseService, matDialog);
  }

  loadLayers() {
    const username = this.form.get("username").value;
    const password = this.form.get("password").value;
    let headers = {};
    if (this.isAuthRequired && username && username.length && password && password.length) {
      const credentials = `${username}:${password}`;
      headers = {
        Authorization: `Basic ${window.btoa(credentials)}`,
      };
      const urlTest = this.url.replace("{x}", "0").replace("{y}", "0").replace("{z}", "0");
      this.http
        .get(urlTest, {
          responseType: "text",
          headers,
        })
        .subscribe(
          () => {
            this.showXYZLayerResultDialog();
          },
          () => {
            this.isLoading = false;
            this.cdr.detectChanges();
            document.getElementById("lblError").innerHTML = "Failed to load url";
          },
        );
    } else {
      this.showXYZLayerResultDialog();
    }
  }

  showXYZLayerResultDialog() {
    const dialog = this.matDialog.open(PhoenixXyzLayerResultsDialogComponent, {
      data: {
        viewerService: this.viewerService,
        url: this.url,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        isAuthRequired: this.isAuthRequired,
      },
      panelClass: "medium-panel-dialog",
      autoFocus: false,
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "";
    });
  }
}
